// core
import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';

const configAxios: AxiosRequestConfig = {
  baseURL: `${process.env.REACT_APP_API_URL}/`,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
  withCredentials: false,
};

const $api: AxiosInstance = axios.create(configAxios);

const configAuthAPI: AxiosRequestConfig = {
  baseURL: `${process.env.REACT_APP_API_AUTH_URL}/`,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
  withCredentials: false,
};

const $apiAuth: AxiosInstance = axios.create(configAuthAPI);

export { $api, $apiAuth };
